import ViewReverse from '../ViewReverse';
import Text from './Text';
import { fontSizes } from '../../constants/constants';
import { cn } from '../../utils/utils';
import { decimal_regix_two } from '../../config/config';
import dynamicfunction from '../../utils/dynamicfunction';
import { getRejectedFieldData, getSectionRejectedFields } from '../../utils/functions';
import ErrorText from './ErrorText';
import { useSelector } from 'react-redux';
import ViewItems from '../ViewItems';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';

const TableInput = ({ value, onChange, placeholder, isDisabled = false, remarksMetadata = null }) => {
  const { isArabic } = dynamicfunction();
  const { rejection_summary, is_rejected, field_codes } = useSelector((state) => state.corporate);

  const handleChange = (e) => {
    const value = e.target.value;
    if (decimal_regix_two.test(value)) onChange(e.target.value);
  };
  const rejectedFields = getSectionRejectedFields(rejection_summary, remarksMetadata?.sectionId);
  const rejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, remarksMetadata?.key);

  const isFieldDisabled = isDisabled || (is_rejected && remarksMetadata && (!rejectedField?.remarks || rejectedField?.remarks?.length < 1));

  return (
    <ViewItems>
      <ViewReverse className={cn('border border-grey rounded-md justify-between overflow-hidden h-10 min-w-28 w-28',
        isFieldDisabled && 'bg-input-bg',
        rejectedField?.remarks?.length > 0 && 'border-red-600',
      )}>
        <input
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          disabled={isFieldDisabled}
          className={cn('text-sm w-[74px] bg-transparent px-2 outline-none text-black',
            rejectedField?.remarks?.length > 0 && 'text-red-600',
            isFieldDisabled && 'text-dark-grey/50 cursor-not-allowed',
          )}
        />
        <div className={cn('h-full px-3 bg-input-bg flex items-center border-grey', isArabic ? 'border-r' : 'border-l')}>
          <Text text='%' size={fontSizes.h14} />
        </div>
      </ViewReverse>
      {rejectedField?.remarks?.length > 0 && (
        <ViewReverse className='items-center gap-2 mt-2'>
          <ReactSVG src={icons.field_info_outline} />
          <ErrorText text={rejectedField?.remarks} className={'mt-0'} />
        </ViewReverse>
      )}
    </ViewItems>
  );
};

export default TableInput;
